export default __webpack_public_path__ + "static/media/1.c2f52743.png";